export default __webpack_public_path__ + "static/media/Trelaze-even.cc952437.png";